import * as React from 'react';
import classNames from 'classnames';

import map from 'lodash/map';

import { DynamicIcon } from '@lumapps/lumx-images/components/DynamicIcon';

/**
 * Used internally by `<Tabs />` to render the tab elements and highlight the active one.
 */
export class Navigation extends React.PureComponent {
    constructor(props) {
        super(props);
        this.selectItem = (occurence) => this.props.onChange(occurence.currentTarget.id);
    }

    render() {
        const { value, items, className, classNameItem, classNameItemActive } = this.props;

        return (
            <div className={className}>
                {map(items, ({ id, label, icon }) => (
                    <a
                        key={id}
                        className={classNames(classNameItem, id === value && classNameItemActive)}
                        id={id}
                        onClick={this.selectItem}
                    >
                        {label && <span>{label}</span>}
                        {icon && <DynamicIcon icon={icon} />}
                    </a>
                ))}
            </div>
        );
    }
}
